
import React, { useState } from "react";

import "./TagsInput.css";

const TagsInput = ({ placeholder = "Add a tag..." }) => {
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      if (!tags.includes(inputValue.trim())) {
        setTags([...tags, inputValue.trim()]);
      }
      setInputValue("");
    } else if (e.key === "Backspace" && inputValue === "" && tags.length > 0) {
      removeTag(tags.length - 1);
    }
  };

  const removeTag = (indexToRemove) => {
    setTags(tags.filter((_, index) => index !== indexToRemove));
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div className="tags-input-container">
      <div className="tags">
        {tags.map((tag, index) => (
          <div key={index} className="tag">
            {tag}
            <span className="tag-close" onClick={() => removeTag(index)}>
              &times;
            </span>
          </div>
        ))}
        <input
          type="text"
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={tags.length === 0 ? placeholder : ""}
          className="tags-input form-control input-lg"
        />
      </div>
    </div>
  );
};

export default TagsInput;
